import CreateImpactContainer from "../containers/CreateImpactContainer";

const CreateImpactPage = () => {
  return (
    <CreateImpactContainer />
  );
};

export default CreateImpactPage;
